import { THIEN_CAN_ORDER, DIA_CHI_ORDER } from './canchi_year.js';
import { DEFAULT_TZ_OFFSET_MINUTES, normalizeTimezoneOffset } from './time.js';

const toLocalHour = (hourInput, timezoneOffsetMinutes) => {
  if (hourInput instanceof Date) {
    const localMs = hourInput.getTime() + timezoneOffsetMinutes * 60 * 1000;
    const localDate = new Date(localMs);
    return localDate.getUTCHours() + localDate.getUTCMinutes() / 60 + localDate.getUTCSeconds() / 3600;
  }
  return Number.isFinite(hourInput) ? hourInput : 0;
};

const normalizeHour = (hourValue = 0) => {
  const safeHour = Number.isFinite(hourValue) ? hourValue : 0;
  const extraDays = Math.floor(safeHour / 24);
  const normalized = ((safeHour % 24) + 24) % 24;
  return { normalized, extraDays };
};

export function getCanChiHour(
  dayCanIndex,
  hourInput,
  { timezoneOffsetMinutes = DEFAULT_TZ_OFFSET_MINUTES } = {}
) {
  const offset = normalizeTimezoneOffset(timezoneOffsetMinutes);
  const hourValue = toLocalHour(hourInput, offset);
  const { normalized: hourLocal } = normalizeHour(hourValue);
  const chiIndex = Math.floor((hourLocal + 1) / 2) % 12;
  const canIndex = (dayCanIndex * 2 + chiIndex) % 10;

  return {
    hour: hourLocal,
    timezoneOffsetMinutes: offset,
    canIndex,
    chiIndex,
    can: THIEN_CAN_ORDER[canIndex],
    chi: DIA_CHI_ORDER[chiIndex],
    label: `${THIEN_CAN_ORDER[canIndex]} ${DIA_CHI_ORDER[chiIndex]}`
  };
}
